// extracted by mini-css-extract-plugin
var _1 = "xvjOA9Y6yvCCkyjTs7YI";
var _2 = "kphBvf02l4KG895Wf8_G";
var _3 = "bvNBNKkMwjII4VYcVxF2";
export { _1 as "menuList", _2 as "menuListLight", _3 as "menuListWithRoundedCorners" }
export default { "menuList": _1, "menuListLight": _2, "menuListWithRoundedCorners": _3 }
